import { useEffect, useState } from 'react';

import type { Theme } from 'loot-core/src/types/prefs';

import { useGlobalPref } from '../hooks/useGlobalPref';

export const themeOptions: [Theme, string][] = [
  ['dark', 'Dark'],
  ['light', 'Light'],
  ['auto', 'System default'],
];

export function useTheme() {
  const [theme = 'auto', setThemePref] = useGlobalPref('theme');
  return [theme, setThemePref] as const;
}

export function ThemeStyle() {
  const [activeTheme] = useTheme();
  const [isDark, setIsDark] = useState<boolean>(false);

  useEffect(() => {
    if (activeTheme === 'auto') {
      function listener(event: MediaQueryListEvent) {
        setIsDark(event.matches);
      }
      const mq = window.matchMedia('(prefers-color-scheme: dark)');
      mq.addEventListener('change', listener);
      setIsDark(mq.matches);
      return () => mq.removeEventListener('change', listener);
    } else {
      setIsDark(activeTheme === 'dark');
    }
  }, [activeTheme]);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', isDark);
  }, [isDark]);

  return null;
}

